import { getLibraryImageUrl, isAiImage } from "../imageLibrary/aiImage";
import { IMAGE_LIBRARY_TYPE } from "../imageLibrary/types";

const useGenerateImageUrl = () => {
  return (file: string, type: string, franchiseId: number) => {
    // Only slider images can be picked from the image library.
    if (isAiImage(file)) {
      return getLibraryImageUrl(file, IMAGE_LIBRARY_TYPE.slider);
    }
    const [version, fileId] = file.split("/");
    return `${
      import.meta.env.VITE_CLOUDINARY_BASE_URL
    }/${version}/order-website/franchise/${type}/${franchiseId}/${fileId}`;
  };
};

export default useGenerateImageUrl;
